export default __webpack_public_path__ + "static/media/icon-settings.ddaa8d14.svg";